"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DueAmount_1 = require("./DueAmount");
exports.default = DueAmount_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/ExpressView/DueAmount/index.js
// module id = 2358
// module chunks = 8